import React, { useState } from "react";
import "../../../style/landing.css";
import { landing_status } from "../constants/Constants_Var";
import { IoMdCheckmarkCircle } from "react-icons/io";
import Model from "../waitlistform/WaitListForm";

const Pricing = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const pricingPlans = [
    {
      name: "Basic Plan",
      description:
        "Perfect for small businesses, individuals starting their newsletter journey",
      features: [
        "Model: GPT-4o Mini",
        "Basic send-time optimization",
        "Limited AI-generated content suggestions",
        "Limited A/B testing",
        "Limited analytics",
        "Supports any 2 Platform Integrations",
      ],
      color: "#FFC700",
      buttonText: "Join Waitlist",
      buttonClass: "purches-btn",
      isAvailable: true,
    },
    {
      name: "Premium Plan",
      description:
        "Ideal for growing businesses ready to scale their email marketing efforts.",
      features: [
        "Model: GPT-3.5 Turbo",
        "Advanced send-time optimization",
        "Enhanced AI-generated content suggestions",
        "Multiple A/B testing",
        "Advanced analytics.",
        "Supports any 5 Platform Integrations",
        "Dedicated account manager & 24/7 support",
      ],
      color: "#0074D9",
      buttonText: "Coming Soon",
      isDisabled: true,
    },
    {
      name: "Enterprise Plan",
      description:
        "Designed for large-scale operations and enterprises with unlimited needs.",
      features: [
        "Model: GPT-4o",
        "Predictive send-time optimization using advanced ML models.",
        "Unlimited AI-generated content suggestions",
        "Unlimited A/B testing with auto-winner selection",
        "Dynamic email personalization based on audience segmentation",
        "AI-driven campaign performance insights and reports",
        "Dedicated account manager & 24/7 support",
      ],
      color: "#00BFA6",
      buttonText: "Coming Soon",
      isDisabled: true,
    },
  ];
  return (
    <>
      <Model
        isOpen={isModalOpen}
        onClose={closeModal}
        name={"inputwaitlist6"}
        status={landing_status.waitlist}
      />
      <div className="price-section">
        <h2 className="lp-product-heading">Our Pricing</h2>

        <h2 className="lp-heading">Flexible Pricing Plans</h2>

        <p className="lp-heading-desc">
          Find the ideal plan tailored to your newsletter goals.
        </p>

        <div className="lp-container">
          <div className="price-container">
            {pricingPlans.map((plan, index) => (
              <div className="price-card" key={index}>
                <h2>{plan.name}</h2>
                <span className="plan-span">{plan.description}</span>
                <div className="service-desc">
                  {plan.features.map((feature, idx) => (
                    <>
                      <p className="service-opt" key={idx}>
                        <IoMdCheckmarkCircle style={{ color: plan.color }} />{" "}
                        {feature}
                      </p>
                      <br />
                    </>
                  ))}
                </div>
                {plan.isAvailable ? (
                  <button
                    className={plan.buttonClass}
                    onClick={() => setIsModalOpen(true)}
                  >
                    {plan.buttonText}
                  </button>
                ) : (
                  <button className="purches-btn-disable">Coming Soon</button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
